import { ApiPaths } from "@shared/constants/ApiPaths";
import { FetcherUtil } from "@shared/utils/fetcherUtil";

export class AuthApi {
  async userInfo(): Promise<
    | { data: UserInfoResponse; success: true }
    | { data: null; success: false; error: string; status: number }
  > {
    return FetcherUtil.json<UserInfoResponse>(ApiPaths.Auth.userInfo);
  }

  async signout(): Promise<
    | { data: null; success: true }
    | { data: null; success: false; error: string; status: number }
  > {
    const response = await fetch(ApiPaths.Gateway.logout, {
      method: "POST",
      credentials: "include",
    });

    if (response.ok) {
      return { data: null, success: true };
    }

    console.error("Logout failed:", response.status, response.statusText);
    const errorData = await response.json();
    return {
      data: null,
      success: false,
      error: errorData.message,
      status: response.status,
    };
  }
}
